<template>
    <main class="container-fluid accessibility-page">
        <section class="row accessibility-section" aria-labelledby="overview-heading">
            <div class="col-12">
                <h2 id="overview-heading" class="section-heading">概要</h2>
                <p>
                    <a
                        href="https://www.docomo.ne.jp/corporate/csr/social/hearty/accessibility/?icid=CRP_CORP_csr_social_hearty_to_CRP_CORP_csr_social_hearty_accessibility"
                        target="_blank"
                        rel="noopener noreferrer"
                    >アクセシビリティ方針</a>に基づき、段階的にウェブアクセシビリティの確保と向上を進めてまいります。
                </p>
            </div>
        </section>

        <section class="row accessibility-section" aria-labelledby="scope-heading">
            <div class="col-12">
                <h2 id="scope-heading" class="section-heading">対象範囲</h2>
                <div class="table-responsive">
                    <table class="table table-bordered scope-table">
                        <colgroup>
                            <col class="scope-page-column">
                            <col class="scope-url-column">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">ページ名</th>
                                <th scope="col">URL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>申告フロー全画面（各種情報内容確認／お問い合わせ状況参照～受付完了）</td>
                                <td>https://dmgreport.web.docomo.ne.jp/ 相当</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

        <section class="row accessibility-section" aria-labelledby="policy-heading">
            <div class="col-12">
                <h2 id="policy-heading" class="section-heading">今後の対応方針</h2>
                <p>未対応、目標基準に達していない箇所については今年度中に修正を進めてまいります。</p>
            </div>
        </section>

        <div class="row text-center">
            <div class="col-12 padding12-top-bottom">
                <button class="btn btn-secondary btn-sm" type="button" @click="closeWindow">閉じる</button>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'AccessibilityInfo',
    methods: {
        closeWindow() {
            window.close()
        },
    },
}
</script>

<style scoped>
.accessibility-page {
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
    padding-right: 15px;
    padding-left: 15px;
    text-align: left;
}

.accessibility-section {
    margin-bottom: 12px;
}

.section-heading {
    margin: 0 0 10px;
    padding: 9px 14px;
    color: rgb(29, 28, 29);
    background: rgb(240, 239, 239);
    font-size: 1rem;
    font-weight: 700;
}

.accessibility-section p {
    margin: 0;
    padding: 0;
    line-height: 1.8;
}

.accessibility-section a {
    color: #0056b3;
    text-decoration: underline;
}

.scope-table {
    margin-bottom: 0;
    font-size: 0.875rem;
    table-layout: fixed;
    width: 100%;
}

.scope-page-column,
.scope-url-column {
    width: 50%;
}

.scope-table th,
.scope-table td {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.scope-table th {
    background: #f6f6f6;
    font-weight: 700;
}
</style>